module.exports = __webpack_public_path__ + "img/logo_alfamart.16ce2b0b.png";